module.exports = __webpack_public_path__ + "static/media/stuart.89ea81b7.png";